import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#1A532F] text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Logo and tagline */}
          <div>
            <h3 className="text-3xl font-bold mb-2 pixel-text">
              unmapped<span className="text-[#F5B041]">.blr</span>
            </h3>
            <p className="text-white/70 text-sm">
              Reimagining Bangalore through heritage walks, games, and workshops
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-[#F5B041]">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#about" className="text-white/70 hover:text-[#F5B041] transition-colors">
                  Who are we?
                </a>
              </li>
              <li>
                <a href="#upcoming-projects" className="text-white/70 hover:text-[#F5B041] transition-colors">
                  Upcoming Projects
                </a>
              </li>
              <li>
                <a href="#walks" className="text-white/70 hover:text-[#F5B041] transition-colors">
                  Heritage Walks
                </a>
              </li>
              <li>
                <a href="#games" className="text-white/70 hover:text-[#F5B041] transition-colors">
                  Games
                </a>
              </li>
              <li>
                <a href="#workshops" className="text-white/70 hover:text-[#F5B041] transition-colors">
                  Workshops
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t-2 border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-white/70">
          <p>© 2024 unmapped.blr. All rights reserved.</p>
          <p className="mt-2 md:mt-0">
            Made with 💚 in Bangalore
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
